import { FlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const AvatarContainer = styled(FlexDiv)`
    width: 40px;
    height: 40px;
    background-color: #f0f0f0;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    color: gray;
`